import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { Hero } from './Hero';
import { CurrentLineup } from './CurrentLineup';
import { CompatibilityTable } from './CompatibilityTable';
import { UsageGuidance } from './UsageGuidance';
import { LegacyAccordion } from './LegacyAccordion';
/**
 * E-Footgear Usage Recommendations page.
 *
 * Self-contained: every section lives in `./` and is owned by this page only.
 */
export function EFootPage() {
  return <div className="min-h-screen bg-gray-50 flex flex-col font-sans text-gray-900" data-id="element-289">
      <Header data-id="element-290" />

      <main className="flex-grow pt-32 pb-20" data-id="element-291">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-292">
          <Hero data-id="element-293" />
          <CurrentLineup data-id="element-294" />
          <CompatibilityTable data-id="element-295" />
          <UsageGuidance data-id="element-296" />
          <LegacyAccordion data-id="element-297" />
        </div>
      </main>

      <Footer data-id="element-298" />
    </div>;
}